module.exports = __webpack_public_path__ + "static/media/beneficios.2659d9f8.png";